import { ChildAccountDisplayObject } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';
import { resetFields } from './resetChildAccountsDisplay';

export const updateName = (
  childAccount: ChildAccountDisplayObject,
  id: string,
  newName: string
): string => {
  return childAccount.uniqueDisplayKey === id ? newName : childAccount.name;
};

export const updateChildAccountName = (
  childAccounts: ChildAccountDisplayObject[],
  newName: string,
  keyOfNameBeingEdited: string
): ChildAccountDisplayObject[] => {
  return childAccounts.map((account) => {
    return {
      ...resetFields(account),
      name: updateName(account, keyOfNameBeingEdited, newName),
    };
  });
};
